import { defineComponent } from "vue";

export default defineComponent({
  name: "letter",
  props: {
    letter: {
      type: Object,
      required: true,
      default: () => {},
    },
    processing: {
      type: Boolean,
      required: true,
      default: () => true,
    },
    managementId: {
        type: Number,
        default: null
    }
  },
  data: () => ({}),
  computed: {
    template() {
      return (
        this.letter.template ||
        Object.assign({
          header_img: null,
          footer_img: null,
          legal_context: null,
          name_one: null,
          position_one: null,
          signature_one: null,
          name_two: null,
          position_two: null,
          signature_two: null,
        })
      );
    },
    headerTemplate() {
      return this.backendPath.concat(`/${this.template.header_img}`);
    },
    petitioner() {
      return (
        this.letter.petitioner ||
        Object.assign({
          name: null,
          labor_union: null,
          city: null,
        })
      );
    },
    businessPartner() {
      return (
        this.letter.business_partner ||
        Object.assign({
          name: null,
          email: null,
          society: null,
          signature: null,
          position: null,
        })
      );
    },
    collaborator() {
      return (
        this.letter.collaborator ||
        Object.assign({
          name: null,
          sharp_id: null,
          cc: null,
          destination: {
            type: null,
            city_name: null,
          },
          origin: {
            type: null,
            city_name: null,
          },
          start_date: null,
          end_date: null,
        })
      );
    },
    management() {
      return (
        this.letter.management ||
        Object.assign({
          price: null,
          state: null,
          path_file: null,
          file_name: null,
          file_upload_date: null,
          comment: null,
          management_date: null,
          airline: null,
        })
      );
    },
    downloadPDF() {
      const { id } = this.$route.params;
      return this.backendPath.concat(
        `/permisos-sindicales/v2/reports/download/licenses/${id}/tickets/${this.managementId}/letter`
      );
    },
    // ## OPTIENE LA FECHA EN QUE SE MODIFICA O SE MODIFICO, DEPENDE DEL EVENTO
    getDate() {
      return this.$moment(this.management.management_date).format(
        "D [de] MMMM [del] YYYY"
      );
    },
    licenseId() {
      return Number(this.$route.params.id || 0);
    },
    dowlandLetterLisence() {
        return this.backendPath.concat(
            `/v2/licenses/${this.licenseId}/download-in-pdf`
        );
    },
    dowlandLetterAproval() {
        return this.backendPath.concat(
            `/v2/licenses/${this.licenseId}/download-approval-in-pdf`
        );
    },
  },
});
